import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    brand_name: "rieave",
    tagline: "ADORN YOUR STORY",
    logo_url: "",
    currency_symbol: "₹",
    free_shipping_threshold: 1499,
    primary_color: "#F3D6E2",
    accent_color: "#C9789A",
    gold_color: "#D4B896",
    charcoal_color: "#3D3140",
  });
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/branding");
      if (data && Object.keys(data).length) setBranding((b) => ({ ...b, ...data }));
    } catch {}
    setLoaded(true);
  };

  useEffect(() => {
    refresh();
  }, []);

  // NOTE: We intentionally do NOT set document.title from this context anymore.
  // Per-page <SeoHead> components (via react-helmet-async) own the page title
  // + meta tags so each page can have its own SEO copy. The fallback title +
  // meta lives in /public/index.html.

  return (
    <BrandingContext.Provider value={{ branding, setBranding, refresh, loaded }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
